import React from 'react';

import Skeleton from '../Base';

const InputSkeleton = () => <Skeleton height="52px" />;

export default InputSkeleton;
